<template>
  <v-main class="primary">
    <transition name="fade" mode="out-in">
      <loader-component v-if="loading"></loader-component>
      <router-view v-else></router-view>
    </transition>
  </v-main>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import LoaderComponent from '../../components/LoaderComponent.vue'
import { MODULOS } from '@/perfiles'

export default {
  components: {
    LoaderComponent,
  },

  async created() {
    this.ENABLE_LOADER()
    this.setThemeByModule(MODULOS.ARMERIA)
    await Promise.all([
      this.fetchCalibres(),
      this.fetchTiposArma(),
      this.fetchMarcaArma(),
      this.fetchEstatusArma(),
      this.fetchArmas(),
      this.fetchTipoAsignacion(),
      this.fetchTiposEntrega(),
      this.fetchEstatusMunicion(),
      this.fetchProcedencia(),
      this.fetchTipoItem(),
      this.fetchMovimientoMunicion(),
      this.fetchMovimientoArma(),
      this.fetchTipoMovimiento(),
      this.fetchClasesArmaCorta(),
      this.fetchClasesArmaLarga(),
      this.fetchSubsedes(),
      this.fetchBitacoraEntregaRecepcion(),
      this.fetchMotivoUso(),
      this.fetchLocs(),
      this.fetchPuestosByDependencia(1),
      this.fetchTipoPuesto(),
      this.fetchTipoFuncion(),
      this.fetchCursos(),
      this.fetchAccesorios(),
    ])
    this.DISABLE_LOADER()
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
    }),
  },

  methods: {
    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('calibre', ['fetchCalibres']),
    ...mapActions('tipoArma', ['fetchTiposArma']),
    ...mapActions('marcaArma', ['fetchMarcaArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('arma', ['fetchArmas']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('tipoEntregaArma', ['fetchTiposEntrega']),
    ...mapActions('estatusMunicion', ['fetchEstatusMunicion']),
    ...mapActions('itemArmeria', ['fetchItems']),
    ...mapActions('procedencia', ['fetchProcedencia']),
    ...mapActions('tipoItemArmeria', ['fetchTipoItem']),
    ...mapActions('movimientoMunicion', ['fetchMovimientoMunicion']),
    ...mapActions('movimientoArma', ['fetchMovimientoArma']),
    ...mapActions('movimientoItem', ['fetchMovimientoItem']),
    ...mapActions('inventario', ['fetchInventario']),
    ...mapActions('tipoMovimientoEquipamiento', ['fetchTipoMovimiento']),
    ...mapActions('claseArma', ['fetchClasesArmaCorta', 'fetchClasesArmaLarga']),
    ...mapActions('subsede', ['fetchSubsedes']),
    ...mapActions('bitacoraEntregaRecepcion', ['fetchBitacoraEntregaRecepcion']),
    ...mapActions('motivoUso', ['fetchMotivoUso']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),
    ...mapActions('puesto', ['fetchPuestosByDependencia']),
    ...mapActions('tipoPuesto', ['fetchTipoPuesto']),
    ...mapActions('tipoFuncion', ['fetchTipoFuncion']),
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('accesorio', ['fetchAccesorios']),

    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
  },
}
</script>
